import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import './main.css'
import './i18n'
import { initSentry } from './utils/sentry'
import { initPwaServiceWorker } from './utils/pwaRegister'

// Initialize Sentry error tracking
initSentry()
initPwaServiceWorker()

/** Early hint for API / storage proxy host — slightly faster first image fetch (album, story assets). */
if (typeof document !== 'undefined') {
  const api = import.meta.env.VITE_API_URL || ''
  if (api.startsWith('http')) {
    try {
      const { origin } = new URL(api)
      const link = document.createElement('link')
      link.rel = 'dns-prefetch'
      link.href = origin
      document.head.appendChild(link)
    } catch {
      /* ignore */
    }
  }
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)
